import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GetCareNowFormatService } from '../../../utilities/getcarenow-format.service';
import { environment } from '../../../../../environments/environment';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-in-person-urgent-care-option-card-mobile',
  imports: [CommonModule, TranslateModule, MatCardModule, MatButtonModule],
  templateUrl: './in-person-urgent-care-option-card.component.html',
  styleUrl: '../../../../../styles.css'
})
export class InPersonUrgentCareOptionCardComponent {
  @Input() providerId!: string;
  @Input() departmentId!: string;
  @Input() name!: string;
  @Input() photo!: string;
  @Input() waitTime!: number;
  @Input() nextAvailability!: string;
  @Input() isOpen: boolean = false;
  @Input() address: string | null = null;
  @Input() distance!: number;
  @Input() imageUrl!: string;
  @Input() locale: string | null = null;
  @Input() isPlus: boolean | null = null;

  private getCareNowFormatService: GetCareNowFormatService;
    
  public soonAsText: string = 'TITLE';
  public virtualVisitText: string = 'DESCRIPTION';
  public reserveText: string = 'RESERVE';
  public walkinText: string = 'WALKIN';
  public vucText: string = '247VUC';
  public milesAwayText: string = 'MILES_AWAY';
  public today: string = 'TODAY';
  public tomorrow : string = 'TOMORROW';
  public openTomorrow: string = 'OPEN_TOMORROW';  
  public waitTimeStr: string = '';

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem("locale") || 'en-US'); // Default to 'en-US' if no locale is provided
    this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
  }
  

  ngOnInit(): void {

    this.waitTimeStr = this.getCareNowFormatService.formatWaitTime(this.waitTime);

   this.translate.get('WALK_IN_WAIT').subscribe((translated: string) => {
      this.soonAsText = translated;
    });

    this.translate.get('MILES_AWAY').subscribe((translated: string) => {
      this.milesAwayText = translated;
    });

    this.translate.get('RESERVE').subscribe((translated: string) => {
      this.reserveText = translated;
    });

    this.translate.get('OPEN_TOMORROW').subscribe((translated: string) => {
      this.openTomorrow = translated;
    });

    this.translate.get('WALKIN').subscribe((translated: string) => {
      this.walkinText = translated;
    });

    this.translate.get('247VUC').subscribe((translated: string) => {
      this.vucText = translated;
    });
  }

  reserveNow() {
    const eptID = sessionStorage.getItem("eptID");
    const isMobile = window.location.href.includes('mobile');

    if (eptID == null || eptID == undefined || eptID == "") {
      this.reserveNowUnAuth(isMobile);
    }
    else {
      this.reserveNowAuth();
    }
  }

  reserveNowUnAuth(isMobile: boolean) {
    // Logic to show more options or details for unauthenticated users
    var deepLink = isMobile ? environment.mobile_omw_deep_link_base_url : environment.web_unauth_omw_deep_link_base_url;
    deepLink += this.departmentId;
    deepLink += "&linksource=PLUAIPUC";

    this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'get-care-now', subfeature: 'IPUC', platform: isMobile ? 'mobile-plus' : 'web' }); // log as web event

    console.log("reserve now clicked (IPUC)");
    console.log(deepLink);

    window.location.href = deepLink;
  }

  reserveNowAuth() {
    var deepLink = '';
    const isPlus = sessionStorage.getItem("isPlus") != null ? sessionStorage.getItem("isPlus") === 'true'  : null;

    if(isPlus == null) {
      deepLink = environment.mobile_omw_deep_link_base_url;
      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event
    } 
    else {
      deepLink = isPlus
          ? environment.mobile_omw_deep_link_base_url // For Plus users, use the mobile deep link
          : environment.epic_omw_deep_link_base_url; //  For non-Plus users, use the epic deep link
    
      var mobilePlatform = isPlus ? 'mobile-plus' : 'mobile-standard';
      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'IPUC', platform: mobilePlatform });
    }
   
    // add provider id and department id params to the deep link
    deepLink += this.departmentId;
    deepLink += "?linksource=AUTHIPUCSCHED";
    
    console.log("reserve now clicked (IPUC)");
    console.log(deepLink);

    window.location.href = deepLink;
  }

  walkinNow() {
    var deepLink = environment.web_google_map + encodeURIComponent(this.address || ''); 
    this.monitoringService.logEvent('WalkinNow', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event  
    window.location.href = deepLink;
  }

  vucNow() {
    const eptID = sessionStorage.getItem("eptID");
    const isMobile = window.location.href.includes('mobile');

    if (eptID == null || eptID == undefined || eptID == "") {
      this.vucNowUnAuth(isMobile);
    }
    else {
      this.vucNowAuth();
    } 
  }

  vucNowUnAuth(isMobile: boolean) {

    // mobile deeplink --> mymemorialcare://openscheduling/standalone?id=7000892&vt=52216,52220
    var deeplink = isMobile ? environment.mobile_open_scheduling_deep_link_base_url : environment.web_open_scheduling_deep_link_base_url; 
    
    deeplink += "/standalone?id=" + environment.generic_vuc_provider_id
      + "&vt=" + environment.adult_vuc_rfv_id;
      
    this.monitoringService.logEvent('VUCNow/NoAuth', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event
    
    console.log("VUC Now clicked (IPUC)");
    console.log(deeplink);
    window.location.href = deeplink;
  
  }

  vucNowAuth() {
    var deepLink = '';

    if (this.isPlus == null) {
      deepLink = environment.web_vuc_deep_link_base_url; // For web users, use the web deep link
      this.monitoringService.logEvent('VUCNow', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event
    }
    else {
      deepLink = this.isPlus == true
        ? environment.mobile_vuc_deep_link_base_url // For Plus users, use the mobile deep link
        : environment.epic_vuc_deep_link_base_url; //  For non-Plus users, use the epic deep link

      var mobilePlatform = this.isPlus ? 'mobile-plus' : 'mobile-standard';
      this.monitoringService.logEvent('VUCNow', { feature: 'get-care-now', subfeature: 'IPUC', platform: mobilePlatform }); // log as mobile or web event
    }

    const age = sessionStorage.getItem("age");
    var ageNumber = age ? parseInt(age) : null;

    if (ageNumber != null) {
        deepLink += ageNumber < 18 
          ? environment.pediatric_vuc_prc_id
          : environment.adult_vuc_prc_id;
    } 
        
    window.location.href = deepLink;
  }
}
